import React from 'react';

import { Dialog, Button, Typography, Stack } from '@gogame/components';

const DiscrepanciesWarningNumber = ({ onClose, open, message, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.Content>
        <Stack spacing={2}>
          <Typography variant={'h6'}>Amount Discrepancies Warning</Typography>
          <Typography>{message}</Typography>
        </Stack>
      </Dialog.Content>

      <Dialog.Actions>
        <Dialog.CloseButton label={'Cancel'} />
        <Button onClick={onSubmit}>Save</Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default DiscrepanciesWarningNumber;
